'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.hide = exports.show = undefined;

var _Overlay = require('./Overlay');

/**
 *
 *   <div class="overlay" data-overlay></div> in theme.liquid
 *
 */

var dom = {
  body: $('body'),
  modal: $('[data-modal]'),
  modalShow: '[data-modal-show]',
  modalHide: '[data-modal-hide]',
  overlay: '[data-overlay]',
  modalForm: '[data-modal-form]',
  modalFormField: '[data-modal-form-field]'
};

var triggerTarget = false;

var show = exports.show = function show(modalName) {
  (0, _Overlay.show)();
  $(dom.body).attr('data-active-modal', modalName);
  var $modal = $('[data-modal="' + modalName + '"]');
  var useCSS = $modal.hasClass('is-transition-css');
  if ($modal.length && $modal[0].hasAttribute('overlay-noclick')) {
    $(dom.overlay).addClass('is-no-click');
  }
  if (useCSS) $modal.addClass('is-active');else $modal.fadeIn(300);

  setTimeout(function () {
    $modal.find('button').eq(0).trigger('focus');
  }, 300);
};

var hide = exports.hide = function hide() {
  (0, _Overlay.hide)();
  var activeModalName = $(dom.body).attr('data-active-modal') || false;
  if (activeModalName) {
    var $modal = $('[data-modal="' + activeModalName + '"]');
    var useCSS = $modal.hasClass('is-transition-css');
    $(dom.body).removeAttr('data-active-modal');
    if (triggerTarget) $(triggerTarget).trigger('focus');
    triggerTarget = false;
    if (useCSS) {
      return $modal.removeClass('is-active');
    }
    return $modal.fadeOut(300);
  }
};

var bindUIActions = function bindUIActions() {
  $(document).on('click', dom.modalShow, function (event) {
    event.preventDefault();
    triggerTarget = event.currentTarget;
    show($(event.currentTarget).attr('data-modal-show'));
  });

  $(document).on('click', dom.modalHide, function (event) {
    event.preventDefault();
    hide();
  });

  $(document).on('focus', dom.modalFormField, function (event) {
    var $modal = $(event.currentTarget).closest(dom.modal);

    $modal.animate({
      scrollTop: $(event.currentTarget).offset().top
    }, 300);
  });
};

var init = exports.init = function init() {
  bindUIActions();
  console.log('[BVA] Component Loaded: Modal');
};